"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugDVSClient = exports.DVSClientClass = exports.snakeCase = exports.getDefaultEdgeUrl = void 0;
var version_1 = require("./version");
var Sentry = __importStar(require("@sentry/minimal"));
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
var fetch_retry_1 = __importDefault(require("fetch-retry"));
require("abortcontroller-polyfill/dist/polyfill-patch-fetch");
var quick_lru_1 = __importDefault(require("@alloc/quick-lru"));
var object_hash_1 = __importDefault(require("object-hash"));
/**
 * `getDefaultEdgeUrl` is a helper method to get the right edge service for
 * calls.
 *
 * `test` and `development` environments will use staging by default. Others
 * will use production.
 *
 * TODO: Internal edge url for service/SSR usage?
 * @param env Current environment as a string
 * @returns DVES staging or prod URLs
 */
function getDefaultEdgeUrl(env) {
    switch (env === null || env === void 0 ? void 0 : env.toLowerCase()) {
        case 'test':
        case 'development':
            return 'https://dynamic-values-edge-service.doorcrawl.com';
        case 'production':
        case 'prod':
        default:
            return 'https://dynamic-values-edge-service.doordash.com';
    }
}
exports.getDefaultEdgeUrl = getDefaultEdgeUrl;
/**
 * A quick snake case utility to normalize variable names in exposure events.
 * @param s Variable name (eg, userId or user_id)
 * @returns snake cased variable name
 */
var snakeCase = function (s) {
    return s.replace(/([A-Z])/g, '_$1').toLowerCase();
};
exports.snakeCase = snakeCase;
var libraryContext = {
    calling_context: 'JS DVES Client',
    library_version: (0, version_1.libraryVersion)().toString(),
};
var isServer = typeof window === 'undefined';
var defaultEvaluationCacheConfig = isServer
    ? { maxSize: 2500, maxAge: 60000 }
    : { maxSize: 50 };
var defaultExposureCacheConfig = isServer
    ? { maxSize: 7500, maxAge: 180000 }
    : { maxSize: 500 };
var excludeKeys = function (key) {
    return ['application', 'os', 'app_version'].includes(key);
};
var getCacheKey = function (name, context) {
    return "".concat(name, "|").concat((0, object_hash_1.default)(context, { excludeKeys: excludeKeys }));
};
var DVSClientClass = /** @class */ (function () {
    function DVSClientClass(config) {
        var _this = this;
        this.lastUsedEvaluationContext = {}; // this is only used by the browser
        // tslint:disable-next-line:prefer-array-literal
        this.evaluateStartHandlers = [];
        // tslint:disable-next-line:prefer-array-literal
        this.evaluateEndHandlers = [];
        this.fetchEvaluatedDVs = function (context) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // TODO: Update default to prod when ready
            var baseUrl = (_a = _this.httpConfig.dvsEdgeUrl) !== null && _a !== void 0 ? _a : getDefaultEdgeUrl((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV);
            var controller = new AbortController();
            var timeout = setTimeout(function () { return controller.abort(); }, (_c = _this.httpConfig.timeout) !== null && _c !== void 0 ? _c : 5000);
            var app = _this.appConfig;
            // TODO: add warnings about missing app config
            return _this.fetch("".concat(baseUrl, "/v1/experiments/"), {
                method: 'POST',
                signal: controller.signal,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    namespaces: (_d = app.namespaces) !== null && _d !== void 0 ? _d : [],
                    legacy_namespaces: (_e = app.legacyNamespaces) !== null && _e !== void 0 ? _e : [],
                    application: (_f = app.application) !== null && _f !== void 0 ? _f : '',
                    app_version: (_g = app.appVersion) !== null && _g !== void 0 ? _g : '',
                    exposures_enabled: (_h = app.exposuresEnabled) !== null && _h !== void 0 ? _h : false,
                    os: 'web',
                    context: context,
                }),
            })
                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                var json, errorJson, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clearTimeout(timeout);
                            if (!res.ok) return [3 /*break*/, 2];
                            return [4 /*yield*/, res.json()];
                        case 1:
                            json = _a.sent();
                            return [2 /*return*/, json];
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, res.json()];
                        case 3:
                            errorJson = _a.sent();
                            this.logDVSErrorResponse(errorJson);
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            this.logDVSErrorResponse({
                                error: 'library_error',
                                message: 'could not handle error from DVES',
                                details: err_1,
                            });
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, {}];
                    }
                });
            }); })
                .catch(function (err) {
                _this.logDVSErrorResponse({
                    error: err.name,
                    details: err,
                });
                if (err.name === 'AbortError') {
                    // timeout
                }
                else {
                    // other errors
                }
                return {};
            });
        };
        /**
         * `evaluate` calls the DVS edge service to evaluate DVs, combining the
         * provided context with the client config passed to `init`
         *
         * Evaluated DVs will be cached in the client, for access via `GetValue`
         * functions.
         *
         * In case a DV fails to evaluate, fall back to previously evaluated results,
         * if possible.
         *
         * @return the server formatted context
         */
        this.evaluate = function (context) { return __awaiter(_this, void 0, void 0, function () {
            var dvResponse, evaluatedDVs, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.evaluateStartHandlers.forEach(function (handler) { return handler(); });
                        dvResponse = this.fetchEvaluatedDVs(context);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dvResponse];
                    case 2:
                        evaluatedDVs = _a.sent();
                        this.lastUsedEvaluationContext = __assign({}, evaluatedDVs === null || evaluatedDVs === void 0 ? void 0 : evaluatedDVs.context);
                        this.populateEvaluationCache(evaluatedDVs, __assign({}, evaluatedDVs === null || evaluatedDVs === void 0 ? void 0 : evaluatedDVs.context));
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this.evaluateEndHandlers.forEach(function (handler) { return handler(); });
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Helper to log error responses from DVES.
         *
         * Error responses are expected to be of the following type:
         * ```
         * type DVESError = {
         *   error: string
         *   message: string
         *   details?: Record<string, unknown>
         * }
         * ```
         * @param errorJson parsed JSON that should contain DVESError fields
         */
        this.logDVSErrorResponse = function (errorJson) {
            if (_this.appConfig.enableSentry) {
                errorJson.message || errorJson.name
                    ? Sentry.captureMessage("".concat(errorJson.name, ": ").concat(errorJson.message))
                    : Sentry.captureException(errorJson.details);
            }
            if (process.env.NODE_ENV !== 'production') {
                var error = errorJson.error, message = errorJson.message, details = errorJson.details;
                console.warn("".concat(error !== null && error !== void 0 ? error : 'unknown_error', ": ").concat(message !== null && message !== void 0 ? message : 'unknown_message'));
                if (details) {
                    console.table(details);
                }
            }
        };
        this.httpConfig = config !== null && config !== void 0 ? config : {};
        this.appConfig = {};
        this.appContext = {};
        this.evaluationCache = new quick_lru_1.default((config === null || config === void 0 ? void 0 : config.evaluationCacheConfig) || defaultEvaluationCacheConfig);
        this.exposureTrackingCache = new quick_lru_1.default((config === null || config === void 0 ? void 0 : config.exposureCacheConfig) || defaultExposureCacheConfig);
        this.fetch = (0, fetch_retry_1.default)(isomorphic_fetch_1.default, __assign({ retries: 2, retryDelay: function (attempt, _error, _response) {
                return Math.pow(2, attempt) * 50;
            } }, this.httpConfig));
    }
    /**
     * `init` sets app config for a DVS client instance, and returns that instance
     */
    DVSClientClass.prototype.init = function (config) {
        var _a;
        this.appConfig = config;
        this.appContext = {
            service: this.appConfig.application,
            app_version: this.appConfig.appVersion,
            os: (_a = this.appConfig.os) !== null && _a !== void 0 ? _a : 'web',
        };
        return this;
    };
    DVSClientClass.prototype.getLastUsedEvaluationContext = function () {
        return this.lastUsedEvaluationContext;
    };
    /**
     * Pub/sub subscriber for starting DV evaluation.
     *
     * The client maintains a list of handlers, so if this function is called
     * multiple times, each handler will be invoked on `evaluate` start.
     * @param handler
     */
    DVSClientClass.prototype.onEvaluateStart = function (handler) {
        this.evaluateStartHandlers.push(handler);
    };
    /**
     * Pub/sub subscriber for completing DV evaluation.
     *
     * The client maintains a list of handlers, so if this function is called
     * multiple times, each handler will be invoked on `evaluate` end.
     * @param handler
     */
    DVSClientClass.prototype.onEvaluateEnd = function (handler) {
        this.evaluateEndHandlers.push(handler);
    };
    /**
     * `getBoolean` returns the evaluated value of a boolean DV.
     *
     * @param dvName Which DV to read the value of
     * @param defaultValue A default value, in case the DV cannot be read
     * @param evaluationContext Context used at evaluation time. This is needed since a server can handle multiple evaluations from different
     * requests simultaneously
     * @param exposureEventContext Context used by telemetry-js to make experiment_exposure event calls correctly
     * @returns
     */
    DVSClientClass.prototype.getBoolean = function (dvName, defaultValue, evaluationContext, exposureEventContext) {
        if (exposureEventContext === void 0) { exposureEventContext = {}; }
        return this.getValue(dvName, defaultValue, evaluationContext, exposureEventContext);
    };
    /**
     * `getNumber` returns the evaluated value of a numeric DV.
     *
     * @param dvName Which DV to read the value of
     * @param defaultValue A default value, in case the DV cannot be read
     * @param evaluationContext Context used at evaluation time. This is needed since a server can handle multiple evaluations from different
     * requests simultaneously
     * @param exposureEventContext Context used by telemetry-js to make experiment_exposure event calls correctly
     * @returns
     */
    DVSClientClass.prototype.getNumber = function (dvName, defaultValue, evaluationContext, exposureEventContext) {
        if (exposureEventContext === void 0) { exposureEventContext = {}; }
        return this.getValue(dvName, defaultValue, evaluationContext, exposureEventContext);
    };
    /**
     * `getString` returns the evaluated value of a string DV.
     *
     * @param dvName Which DV to read the value of
     * @param defaultValue A default value, in case the DV cannot be read
     * @param evaluationContext Context used at evaluation time. This is needed since a server can handle multiple evaluations from different
     * requests simultaneously
     * @param exposureEventContext Context used by telemetry-js to make experiment_exposure event calls correctly
     * @returns
     */
    DVSClientClass.prototype.getString = function (dvName, defaultValue, evaluationContext, exposureEventContext) {
        if (exposureEventContext === void 0) { exposureEventContext = {}; }
        return this.getValue(dvName, defaultValue, evaluationContext, exposureEventContext);
    };
    /**
     * Public method for reading DV values with parametrized types.
     *
     * Client logic should generally use one of the typed variants instead:
     * - `getBoolean`
     * - `getNumber`
     * - `getString`
     *
     * @param dvName Which DV to read the value of
     * @param defaultValue A default value, in case the DV cannot be read
     * @param evaluationContext Context used at evaluation time. This is needed since a server can handle multiple evaluations from different
     * requests simultaneously
     * @param exposureEventContext Context used by telemetry-js to make experiment_exposure event calls correctly
     * @returns
     */
    // TODO: Scope DVType to be one of DynamicValue's options
    DVSClientClass.prototype.getValue = function (dvName, defaultValue, evaluationContext, exposureEventContext) {
        if (exposureEventContext === void 0) { exposureEventContext = {}; }
        var resolvedValue = defaultValue;
        var cacheKey = getCacheKey(dvName, evaluationContext);
        var cacheResponse = this.evaluationCache.get(cacheKey);
        var cachedValue = cacheResponse === null || cacheResponse === void 0 ? void 0 : cacheResponse.value;
        if (cachedValue !== undefined &&
            typeof cachedValue === typeof defaultValue) {
            resolvedValue = cachedValue;
        }
        if (this.shouldSendExposureEvent(cacheKey, resolvedValue)) {
            this.sendExposureEvent(dvName, resolvedValue, cacheKey, evaluationContext, exposureEventContext);
        }
        return resolvedValue;
    };
    DVSClientClass.prototype.populateEvaluationCache = function (dvsResponse, evaluationContext) {
        var _this = this;
        var successes = dvsResponse === null || dvsResponse === void 0 ? void 0 : dvsResponse.successes;
        var failures = dvsResponse === null || dvsResponse === void 0 ? void 0 : dvsResponse.failures;
        if (successes) {
            successes.forEach(function (success) {
                var cacheKey = getCacheKey(success.name, evaluationContext);
                _this.evaluationCache.set(cacheKey, {
                    value: success.value,
                    isFallback: false,
                    exposure_enabled: success.exposure_enabled,
                    exposure_context: success.exposure_context,
                });
            });
        }
        if (failures) {
            failures.forEach(function (failure) {
                var cacheKey = getCacheKey(failure.name, evaluationContext);
                var previousEvaluation = _this.evaluationCache.get(cacheKey);
                // fallback to previous value, if available
                if (previousEvaluation) {
                    _this.evaluationCache.set(cacheKey, {
                        value: previousEvaluation.value,
                        isFallback: true,
                        exposure_enabled: previousEvaluation.exposure_enabled,
                        exposure_context: previousEvaluation.exposure_context,
                    });
                }
            });
        }
    };
    /**
     * Helper to check if an exposure event should fire. Check the dynvamic value exposure_enabled flag,
     * and whether an event has already been generated for this (cacheKey, result) pair
     *
     * If an event has already been generated and cached, we do not need to send
     * another.
     *
     * @param cacheKey key to look up in exposure cache
     * @param result Latest resolved result
     * @returns Whether to send a new exposure event for (cacheKey, result)
     */
    DVSClientClass.prototype.shouldSendExposureEvent = function (cacheKey, result) {
        var _a;
        var dvesExposureEnabled = (_a = this.evaluationCache.get(cacheKey)) === null || _a === void 0 ? void 0 : _a.exposure_enabled;
        return ((typeof dvesExposureEnabled === 'boolean'
            ? dvesExposureEnabled
            : false) && this.exposureTrackingCache.get(cacheKey) !== result);
    };
    /**
     * Send an exposure event for this (name, result) pair, and track that event
     * in the exposure cache.
     *
     * This method will only generate telemetry events if `init` was called with
     * a TelemetryClient.
     *
     * @param name DV name for the exposure event
     * @param result DV result for the exposure event
     * @param isDefault TODO - what properties do we need?
     */
    DVSClientClass.prototype.sendExposureEvent = function (name, result, cacheKey, evaluationContext, exposureEventContext) {
        var _a, _b;
        var telemetry = this.appConfig.telemetry;
        if (telemetry) {
            var dvesExposureContext = (_b = (_a = this.evaluationCache.get(cacheKey)) === null || _a === void 0 ? void 0 : _a.exposure_context) !== null && _b !== void 0 ? _b : {};
            telemetry.event('experiment_exposure', __assign(__assign(__assign(__assign({ experiment_name: name, result: result, exposure_time: Date.now() }, dvesExposureContext), libraryContext), this.appContext), evaluationContext), exposureEventContext);
            this.exposureTrackingCache.set(cacheKey, result);
        }
    };
    return DVSClientClass;
}());
exports.DVSClientClass = DVSClientClass;
var DebugDVSClient = /** @class */ (function (_super) {
    __extends(DebugDVSClient, _super);
    function DebugDVSClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Utility method for testing the DVS evaluation cache.
     *
     * @returns A stringified version of the current DVS evaluation cache
     */
    DebugDVSClient.prototype.logEvaluationCache = function () {
        var e_1, _a;
        var cache = {};
        try {
            for (var _b = __values(this.evaluationCache.entriesAscending()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                cache[key] = val;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return JSON.stringify(cache, null, 2);
    };
    return DebugDVSClient;
}(DVSClientClass));
exports.DebugDVSClient = DebugDVSClient;
//# sourceMappingURL=dvsClient.js.map